import { init as initConfig } from 'config';
import PreferencesPage from 'preferences/PreferencesPage';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'theme-ui';

import './index.css';
import 'semantic-ui-less/semantic.less';

import LogApi from 'api/LogApi';
import axiosInstance, { init as initAxios } from 'client';
import { initInterceptors } from 'client/interceptors';

import App from './App';
import { ApplicationPaths } from './auth/AuthorizationConstants';
import { AuthAction } from './auth/AuthorizationRoutes';
import { isAuthenticated, signInSilent } from './auth/AuthorizeService';
import { LandingPage } from './components/LandingPage';
import * as serviceWorker from './serviceWorker';
import theme from './theme';

// Match the URL for authentication related routes
const authRegex = new RegExp(`${ApplicationPaths.AuthorizationPrefix}/(.+)`);
const authUrlMatch = window.location.pathname.match(authRegex);

initConfig()
  .then(config => {
    initAxios(config);
    initInterceptors(axiosInstance);

    LogApi.sendLog('debug', `Initialized axios and checking if user is logged in`);

    // Intercept authentication urls so authentication actions can be immediately triggered
    if (authUrlMatch && authUrlMatch[1]) {
      return AuthAction(authUrlMatch[1]);
    }
    return Promise.resolve('success');
  })
  .then(status => {
    if (status !== 'success') return false;
    return isAuthenticated() // Authentication Actions like login will have logged in by here
      .catch(() => false);
  })
  .then(async loggedIn => {
    if (window.location.pathname.match(/\/email-preferences/i)) {
      document.getElementById('loading-screen').remove();

      ReactDOM.render(
        <ThemeProvider theme={theme}>
          <PreferencesPage />
        </ThemeProvider>,
        document.getElementById('root')
      );
    } else if (!loggedIn) {
      // Send the user to the Landing Page
      LogApi.sendLog('debug', `User is not logged in, redirecting to landing page`);
      ReactDOM.render(<LandingPage authUrlMatch={authUrlMatch} />, document.getElementById('root'));
    } else if (authUrlMatch) {
      // Re-route the user of a invalid authentication URL to root page
      window.location.replace('/');
    } else {
      await signInSilent(); // Force refresh of access token
      LogApi.sendLog('debug', `User is logged in, rendering map and application`);
      document.getElementById('loading-screen').remove();
      ReactDOM.render(<App />, document.getElementById('root'));
    }
  })
  .catch(err => {
    const errStack = err.stack || err || 'No stack information available';
    LogApi.sendLog('error', `Failed to load application:\n${err?.message}\n${errStack}`);

    if (authUrlMatch) {
      // Re-route the user of a invalid authentication URL to root page
      window.location.replace('/');
      return;
    }

    document.getElementById('loading-screen')
      ? (document.getElementById('loading-screen').innerHTML =
          '<span class="load-error">Failed to load application. Please try reloading.</span>')
      : (document.getElementById('root').innerHTML =
          '<div class="loading-screen"><span class="load-error">Failed to load application. Please try reloading.</span></div>');
    console.error('Failed to load application configuration. Please try reloading.');
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
